const RELOAD_KEY = 'chunk-reload-at';
const RELOAD_COOLDOWN_MS = 60_000;

const isChunkLoadError = (error: Error): boolean =>
  error.name === 'ChunkLoadError' || /Loading chunk .* failed/.test(error.message);

/**
 * A deploy (or instances running different builds) can remove chunks an open
 * page still references. Reload to pick up the current build, at most once per
 * cooldown window so a genuinely broken build can't cause a reload loop.
 */
export const reloadOnChunkLoadError = (error: Error): void => {
  if (!isChunkLoadError(error)) return;
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
    if (Date.now() - last < RELOAD_COOLDOWN_MS) return;
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    window.location.reload();
  } catch {}
};
